'use strict';
import { module } from '../app';
import * as _ from 'lodash';

export class SelectProblemsDialogModel {
  constructor(problems, locations) {
    this.modalInstance = null;
    this.isCancelled = false;
    this.problems = _.cloneDeep(problems);
    this.locations = locations;
    this.dropdownMultiSelectSetting = {
      checkBoxes: true,
      scrollableHeight: '200px',
      scrollable: true,
      displayProp: 'Value',
      smartButtonMaxItems: 2,
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonTextProvider(selectionArray) {
        return selectionArray.map((elem) => elem.Value).join(", ");
      },
      template: '{{option.Value}}',
      idProperty: 'Code'
    };
    this.dropdownMultiSelectText = {
      buttonDefaultText: 'Select Locations'
    };
  }

  init(modal, scope) {
    this.modalInstance = modal;
    this._scope = scope;

    scope.model.problems.forEach((problem) => {
      const selectedLocations = [];
      if (problem.Location) {
        const locationCodeArr = problem.Location.split(';');
        locationCodeArr.forEach((code) => {
          const locationItem = scope.model.locations.find((_) => _.Code === code);
          if (locationItem) {
            selectedLocations.push(locationItem);
          }
        });
      }
      problem.selectedLocations = selectedLocations;
    });
  }

  isSeparator(item) {
    return !!(item && item.Value.indexOf("----") !== -1 || item.Value.indexOf("Indicated Problems") !== -1 || item.Value.indexOf("Risk Factor(s)") !== -1);
  }

  isSideSpecified(item) {
    return item.IsLeft || item.IsRight || item.IsBoth;
  }

  updateProblemUnspecified(p) {
    if (p.IsUnspecified) {
      p.IsLeft = false;
      p.IsRight = false;
      p.IsBoth = false;
      p.Location = '';
    }
  }

  updateProblemSide(p, isBothChecked) {
    if (p.IsLeft || p.IsRight || p.IsBoth) {
      p.IsUnspecified = false;
    }
    if(!isBothChecked && p.IsBoth){
      p.IsBoth = false;
    }
    if(p.IsBoth || p.IsLeft && p.IsRight){
      p.IsRight = false;
      p.IsLeft = false;
      if(!p.IsBoth){
        p.IsBoth = true;
      }
    }
  }

  ok() {
    if (this.problems && _.isArray(this.problems)) {
      this.problems.forEach((problem) => {
        problem.Location = '';
        const selectedLocations = problem.selectedLocations;
        if (selectedLocations && _.isArray(selectedLocations)) {
          problem.Location = selectedLocations.map((elem) => elem.Code).join(";");
        }
        problem.selectedLocations = null;
      });
    }

    this.isCancelled = false;
    this.modalInstance.remove();
  }

  cancel() {
    this.isCancelled = true;
    this.modalInstance.remove();
  }
}

module
  .factory('SelectProblemsDialogModel', [ function () {
    return SelectProblemsDialogModel;
  } ]);



// WEBPACK FOOTER //
// ./src/scripts/models/selectProblems.js